import anime from 'animejs';
import { durations } from 'components/menu/motion';
import scroll from 'core/scroll';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import { EASE_IN, EASE_OUT, frameToMs } from 'helpers/easings';
import Component from 'navigation/component/Component';
import store from 'store';
import mqStore from 'store/mqStore';
export default class PageHeader extends Component {
    _descriptionOpened = false;
    _selectOpened = false;
    get descriptionOpened() {
        return this._descriptionOpened;
    }
    get selectOpened() {
        return this._selectOpened;
    }
    set descriptionOpened(value) {
        this._descriptionOpened = value;
        this.refs.description.classList.toggle('opened', value);
    }
    set selectOpened(value) {
        this._selectOpened = value;
        this.translateDrawer(value);
    }
    drawerAnims = [];
    motions = [];
    initialized() {
        super.initialized();
        this.updateTitleScrollPosition();
        this.resize();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        window[method]('click', this.handleDocumentInteraction.bind(this));
        if (this.refs.selectToggle)
            this.refs.selectToggle[method]('click', this.toggleSelect);
        store.drawer.toggleListener(add, this.onDrawerUpdate);
        this.refs.selectLinks?.forEach((link) => {
            link[method]('mouseenter', this.onLinkMouseEnter);
            link[method]('mouseleave', this.onLinkMouseLeave);
            link[method]('click', this.onLinkClick);
        });
        if (this.refs.viewMore)
            this.refs.viewMore[method]('click', this.toggleDescription);
        if (this.refs.viewLess)
            this.refs.viewLess[method]('click', this.toggleDescription);
        if (this.refs.selectClose)
            this.refs.selectClose[method]('click', this.toggleSelect);
        if (this.refs.pageHeaderTitle)
            this.refs.pageHeaderTitle[method]('scroll', this.onPageTitleScroll);
        if (this.refs.pageHeaderTitle)
            this.refs.pageHeaderTitle[method]('touchstart', this.onPageTitleScroll);
        if (this.refs.pageHeaderTitle)
            this.refs.pageHeaderTitle[method]('touchmove', this.onPageTitleScroll);
        if (this.refs.pageHeaderTitle)
            this.refs.pageHeaderTitle[method]('touchend', this.onPageTitleScroll);
        scroll[emitterMethod](this.onScroll);
    }
    onLinkClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.selectOpened = false;
        store.drawer.set(null);
        this.toggleSelect();
    };
    isEllipsisActive = () => {
        if (this.refs.descriptionInner) {
            const h = Math.round(this.refs.descriptionInner.getBoundingClientRect().height);
            return (h - this.refs.descriptionInner.scrollHeight) < -3;
        }
        else {
            return false;
        }
    };
    onScroll = () => {
        if (this.refs.select && this.selectOpened) {
            store.drawer.set(null);
            this.toggleSelect();
        }
    };
    onLinkMouseEnter = (e) => {
        this.refs.selectLinks.forEach((link) => {
            link.className = 'inactive';
            if (link === e.target)
                link.className = 'active';
        });
    };
    onLinkMouseLeave = (e) => {
        this.refs.selectLinks.forEach((link) => {
            link.classList.remove('active');
            link.classList.remove('inactive');
        });
    };
    toggleSelect = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            store.drawer.set(this.selectOpened ? null : 'page-header-select');
        }
        const duration = 300;
        let m, m1;
        m = anime({
            targets: this.refs.chevronUp,
            translateY: this.selectOpened ? ['-20%', 0] : [0, '-20%'],
            opacity: this.selectOpened ? [0, 1] : [1, 0],
            duration,
            easing: EASE_OUT
        });
        m1 = anime({
            targets: this.refs.chevronDown,
            translateY: this.selectOpened ? [0, '20%'] : ['20%', 0],
            opacity: this.selectOpened ? [1, 0] : [0, 1],
            duration,
            easing: EASE_OUT
        });
        this.motions.push(m, m1);
    };
    toggleDescription = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.descriptionOpened = !this.descriptionOpened;
    };
    onDrawerUpdate = () => {
        if (this.selectOpened !== (store.drawer.get() === 'page-header-select')) {
            this.cancelMotions();
            this.selectOpened = store.drawer.get() === 'page-header-select';
            if (!this.selectOpened)
                this.toggleSelect();
        }
    };
    translateDrawer = (value) => {
        const isTabletPortrait = mqStore.tabletPortrait.get();
        let m, m1;
        if (isTabletPortrait) {
            m = anime({
                targets: this.refs.select.children[0],
                translateY: {
                    value: value ? ['100%', '0'] : ['0', '100%'],
                    duration: value ? frameToMs(40) : durations.FIRST_PANEL_TRANSLATE_OUT,
                    easing: value ? EASE_OUT : EASE_IN
                },
                opacity: {
                    value: value ? [0, 1] : [1, 0],
                    duration: value ? durations.FIRST_PANEL_OPACITY_IN : durations.FIRST_PANEL_OPACITY_OUT,
                    easing: 'linear',
                    delay: value ? 0 : frameToMs(10)
                },
                begin: () => {
                    if (value)
                        this.refs.select.classList.toggle('opened', value);
                },
                complete: () => {
                    if (!value)
                        this.refs.select.classList.toggle('opened', value);
                }
            });
            m1 = anime({
                targets: this.refs.select.children[0].children,
                opacity: value ? [0, 1] : [1, 0],
                duration: value ? durations.FIRST_PANEL_OPACITY_IN : durations.FIRST_PANEL_OPACITY_OUT,
                easing: 'linear'
            });
        }
        else {
            if (value) {
                this.refs.select.classList.toggle('opened', value);
                /* WRAPPER */
                m = anime({
                    targets: this.refs.select.children[0],
                    translateY: {
                        value: [-70, 0],
                        easing: EASE_OUT,
                        duration: frameToMs(50)
                    },
                    opacity: {
                        value: [0, 1],
                        easing: 'linear',
                        duration: frameToMs(10),
                        delay: frameToMs(10)
                    }
                });
                /* LINKS */
                m1 = anime({
                    targets: this.refs.selectLinks,
                    translateY: {
                        value: [-25, 0],
                        easing: EASE_OUT,
                        duration: frameToMs(40),
                        delay: anime.stagger(frameToMs(1), { start: frameToMs(10) })
                    },
                    opacity: {
                        value: [0, 1],
                        easing: 'linear',
                        duration: frameToMs(20),
                        delay: anime.stagger(frameToMs(1), { start: frameToMs(10) })
                    }
                });
            }
            else {
                /* WRAPPER */
                m = anime({
                    targets: this.refs.select.children[0],
                    translateY: {
                        value: [0, -70],
                        easing: EASE_IN,
                        duration: frameToMs(50),
                        delay: frameToMs(10)
                    },
                    opacity: {
                        value: [1, 0],
                        easing: 'linear',
                        duration: frameToMs(10),
                        delay: frameToMs(20)
                    },
                    complete: () => {
                        this.refs.select.children[0].style.transform = '';
                        this.refs.selectLinks.forEach((link) => {
                            link.style.opacity = '';
                            link.style.transform = '';
                        });
                        this.refs.select.classList.toggle('opened', value);
                    }
                });
                // /* LINKS */
                m1 = anime({
                    targets: this.refs.selectLinks,
                    translateY: {
                        value: [0, -25],
                        easing: EASE_IN,
                        duration: frameToMs(40),
                        delay: anime.stagger(frameToMs(1), { direction: 'reverse' })
                    },
                    opacity: {
                        value: [1, 0],
                        easing: 'linear',
                        duration: frameToMs(20),
                        delay: anime.stagger(frameToMs(1), { direction: 'reverse' })
                    }
                });
            }
        }
        this.motions.push(m, m1);
    };
    handleDocumentInteraction(e) {
        if (!this.selectOpened)
            return;
        const target = e.target;
        if (!this.refs.select.contains(target) && this.selectOpened) {
            if (target.closest('.header-menu')) {
                this.selectOpened = false;
                store.drawer.set('menu');
                this.toggleSelect();
            }
            else {
                this.selectOpened = false;
                store.drawer.set(null);
                this.toggleSelect();
            }
        }
    }
    updateSelectPosition() {
        if (!this.refs.select || !this.refs.selectTitle)
            return;
        const selectTitleWidth = this.refs.selectTitle.offsetWidth;
        const gap = 8;
        const left = selectTitleWidth + gap;
        if (this.refs.select)
            this.refs.select.style.left = `${left}px`;
    }
    updateTitleScrollPosition() {
        if (!this.refs.pageHeaderTitle)
            return;
        const limit = this.refs.pageHeaderTitle.scrollWidth - this.refs.pageHeaderTitle.offsetWidth;
        this.refs.pageHeaderTitle.scrollBy({ left: limit });
    }
    onPageTitleScroll = () => {
        if (!this.refs.pageHeaderTitle)
            return;
        const limit = this.refs.pageHeaderTitle.scrollWidth - this.refs.pageHeaderTitle.offsetWidth;
        this.refs.pageHeaderTitle.parentElement.classList.toggle('left', this.refs.pageHeaderTitle.scrollLeft > 0);
        this.refs.pageHeaderTitle.parentElement.classList.toggle('right', this.refs.pageHeaderTitle.scrollLeft < limit);
    };
    resize() {
        super.resize();
        // if mobile, we don't need to update the position
        const isTabletPortrait = mqStore.tabletPortrait.get();
        if (this.refs.descriptionInner) {
            if (this.isEllipsisActive())
                this.refs.actions.classList.add('visible');
            else
                this.refs.actions.classList.remove('visible');
        }
        if (isTabletPortrait) {
            if (this.refs.select)
                this.refs.select.style.left = '0';
            return;
        }
        this.updateSelectPosition();
        this.updateTitleScrollPosition();
    }
    cancelMotions() {
        this.motions.forEach((m) => {
            if (m)
                m.pause();
        });
        this.motions = [];
    }
    flush() {
        super.flush();
    }
}
